import { createContext, Dispatch } from 'react';
import { initialState, ReducerAction, ReducerState } from './reducer';

type CampaignContextValue = {
  state: ReducerState;
  dispatch: Dispatch<ReducerAction>;
};

export const CampaignContext = createContext<CampaignContextValue>({
  state: initialState,
  dispatch: () => void {},
});
